import { ESubscribeMode, IReolinkAddresses, IUserAddresses, TAddress, TAddressType } from '@reolink-cloud/interface';
import i18n from '@/lang/reolink';

export function hasAddress( addressObj: { billingInfos?: any[];shippingInfos?: any[]; }|null ): boolean {

    return ( addressObj?.billingInfos?.length ?? 0 ) + ( addressObj?.shippingInfos?.length ?? 0 ) >= 1;

}

export function getCheckoutButtonText( mode: ESubscribeMode, needPay: boolean, showSwitchInfo: boolean ): string {

    let finalMode = mode;
    if ( mode === ESubscribeMode.SWITCH && !showSwitchInfo ) {

        finalMode = ESubscribeMode.CREATE;

    }
    const pay = !needPay ? 'free' : 'pay';
    return mode ? i18n.tc( `cart.checkout.${finalMode}.${pay}` ) : '';

}

export function getAddressArr( addressObj: IUserAddresses|IReolinkAddresses, type: TAddressType ): TAddress[] {

    switch ( type ) {

        case 'billing':{

            return addressObj.billingInfos;

        }
        case 'shipping':{

            return addressObj.shippingInfos;

        }

    }

}

export function checkSubIdValid( subId: unknown ): boolean {

    return typeof subId === 'string' && !['0', ''].includes( subId );

}
